if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', (e) => {
  const breakpoint = window.matchMedia('(min-width:990px)');
  const breakpointChecker = function(e) {
    if ( breakpoint.matches === false ) {
      if (document.querySelector('.container:not(.template-quickview) .product__info-container.product__column-sticky') != null) {
        document.querySelector('.container:not(.template-quickview) .product__info-container.product__column-sticky').style.top = `unset`;
      }
      document.querySelector('.product-media-gallery-slider .product__media-list').classList.remove('grid', 'grid--peek');
      document.querySelectorAll('.product-media-gallery-slider .product__media-list li').forEach(item => item.classList.remove('grid__item'));

      var productRecreateSlider = document.querySelector('slide-element.productMediaSwiperGallery .swiper-slider');
      let sliderOptions = productRecreateSlider.getAttribute('slider-option');
      sliderOptions = JSON.parse(sliderOptions);
      let sliderInstance = new Swiper(productRecreateSlider, sliderOptions);
      productGallerySlider = sliderInstance;
	    return;
    } else if ( breakpoint.matches === true ) {
      if (document.querySelector('.container:not(.template-quickview) .product__info-container.product__column-sticky') != null) {
        var offsetHeight = document.querySelector('.shopify-section-group-header-group.section-header').offsetHeight;
        document.querySelector('.container:not(.template-quickview) .product__info-container.product__column-sticky').style.top = `${offsetHeight}px`; 
      }
      if(productGallerySlider === undefined || productGallerySlider.destroyed == true) return;
      document.querySelector('.product-media-gallery-slider .product__media-list').classList.add('grid', 'grid--peek');
      document.querySelectorAll('.product-media-gallery-slider .product__media-list li').forEach(item => item.classList.add('grid__item'));
	    if ( productGallerySlider !== undefined && productGallerySlider.destroyed != true ) {
        productGallerySlider.destroy(true, true);
      }
    }
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
})


